import { createContext, useCallback, useContext, useState } from 'react';

interface QuickAddCtx {
  open: boolean;
  show: () => void;
  close: () => void;
  toggle: () => void;
}

const Ctx = createContext<QuickAddCtx | null>(null);

export function QuickAddProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const show = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => setOpen((v) => !v), []);
  return <Ctx.Provider value={{ open, show, close, toggle }}>{children}</Ctx.Provider>;
}

export function useQuickAdd(): QuickAddCtx {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useQuickAdd must be used inside QuickAddProvider');
  return ctx;
}
